import { render } from "./ProviderTrainingKnowledgeQuiz.vue?vue&type=template&id=78960e82&scoped=true"
import script from "./ProviderTrainingKnowledgeQuiz.vue?vue&type=script&lang=js"
export * from "./ProviderTrainingKnowledgeQuiz.vue?vue&type=script&lang=js"

import "./ProviderTrainingKnowledgeQuiz.vue?vue&type=style&index=0&id=78960e82&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78960e82"]])

export default __exports__